import * as Actions from '../actions/types'
import { login as getToken } from 'API'
import setAuthToken from '../utils/setAuthToken'

export const loginAction = model => dispatch => {
  return getToken(model)
    .then(res => res.data)
    .then(res => {
        sessionStorage.setItem("auth-token", res.access_token);
        sessionStorage.setItem("auth-username", res.userName);
        sessionStorage.setItem("auth-role", res.roles);
        setAuthToken(res.access_token);
        dispatch({
            type: Actions.USER_LOG_IN,
            payload: {
                username: res.userName,
                role: res.roles
            }
        })
    })
}

export function fillAuthAction(token, username, role) {
    return {
        type: Actions.FILL_AUTH,
        payload:{
            token,
            username,
            role
        }
    }
}

export function logoutAction() {
    sessionStorage.removeItem("auth-token");
    sessionStorage.removeItem("auth-user");
    sessionStorage.removeItem("auth-role");
    return {
        type: Actions.USER_LOG_OUT
    }
}

export function setClientIdAction(id) {
    return {
      type: Actions.SET_CLIENT_ID,
      payload:{
          id
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/actions/user.js